import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"
const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const appStoreAction = createAsyncThunk(
    'app-store',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/store/app`, data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const appStoreSlice = createSlice({
    name: 'app-store',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(appStoreAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(appStoreAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(appStoreAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const appStoreReducer = appStoreSlice.reducer